export function defaultBookForm() {
  return {
    title: '',
    category: '',
    author: '',
    type: '',
    year: '',
    publishedDate: '',
    original: '',
    imageurl: '',
    description: '',
    pageCount: '',
    language: 'FR',
    date: new Date().toISOString().substring(0, 10),
    read: 'N',
    rating: '3',
    path: 'G:/books',
    filename: '',
    tag: '',
    marked: '',
  }
}

export function timeConvert(minutes) {
  const hours = Math.floor(minutes / 60)
  const mins = minutes % 60
  return `${hours}h${mins}`
}

export function appendBookFormData(formData, book) {
  Object.entries(book).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      formData.append(key, String(value))
    }
  })
}

export function posterSrc(book) {
  if (book?.imageurl) return book.imageurl
  if (book?.image) return `/uploads/${book.image}`
  return ''
}
